export const config = {
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '889506198779-9lef8in9pdqk176fbbnfv7578cbh1m77.apps.googleusercontent.com',
  linkedInClientId:  '86ta1l0jhke5ed',
  linkedInRedirectUri:'https://app.carion.group/login'
};
